import { TranslateService } from '@ngx-translate/core';
import { RBCheck } from '@lfw/roesberg';
import { v4 as uuidv4 } from 'uuid';

export class MenuCommand {
  public readonly id = uuidv4();
  public icon = '';
  public route = '';
  public transId = '';
  public customText = '';
  public needProject = false;
  public isExternalRoute = false;

  constructor(private translateService: TranslateService) {}

  get text(): string {
    if (!RBCheck.isNullOrEmpty(this.customText)) {
      return this.customText;
    }
    return this.translateService.instant('COMMANDS.' + this.transId.toUpperCase());
  }
}
